// Lista de palabras altisonantes/ofensivas para filtrar la entrada del chat libre.
//
// Cómo funciona:
// - Cada entrada se compara como INICIO de palabra (prefijo), así una sola raíz
//   cubre variantes: 'puto' bloquea puto/putos/putona; 'ching' bloquea
//   chinga/chingada/chingón/chingar, etc.
// - La comparación normaliza minúsculas y quita acentos, así que escribe las
//   entradas en minúsculas y SIN acentos.
// - Evita raíces que colisionen con palabras válidas tras quitar acentos
//   (p. ej. NO uses 'cono' porque chocaría con "cono" de geometría; tampoco
//   'mama' porque chocaría con "mamá"). Por eso aquí se usan raíces específicas.
//
// Mantenimiento: agrega o quita términos según lo que necesites filtrar.
export const PALABRAS_BLOQUEADAS = [
  'pendej',      // pendejo/a/os/as, pendejada
  'cabron',      // cabrón/a/es
  'ching',       // chinga/chingada/chingar/chingón/chingadera
  'verga',
  'mierda',
  'culer',       // culero/a
  'culo',
  'joto',
  'maric',       // marica/maricón
  'pinche',
  'mamad',       // mamada/mamadas (no usar 'mama' por "mamá")
  'mamon',       // mamón/a
  'puto',
  'puta',
  'idiota',
  'imbecil',
  'estupid',     // estúpido/a
  'tarad',       // tarado/a
  'malparido',
  'hijueputa',
  'hdp',
  'gilipollas',
];

const normaliza = (t) =>
  (t || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '');

// Escapa metacaracteres de regex en una raíz ya normalizada.
const escaparRegex = (s) => s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

/**
 * Devuelve true si el texto contiene alguna palabra de PALABRAS_BLOQUEADAS
 * (comparada como inicio de palabra, ignorando mayúsculas y acentos).
 * @param {string} texto
 * @returns {boolean}
 */
export const contieneLenguajeOfensivo = (texto) => {
  const t = normaliza(texto);
  if (!t) return false;
  return PALABRAS_BLOQUEADAS.some((palabra) => {
    const raiz = escaparRegex(normaliza(palabra));
    return raiz ? new RegExp(`\\b${raiz}`, 'u').test(t) : false;
  });
};
